// This import loads the firebase namespace along with all its type information.
import Tag from './tag-model'

export async function load_tags(): Promise<Tag[]> {
  throw 'Not implemented'
}

export async function delete_tag(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_tag(): Promise<Tag> {
  throw 'Not implemented'
}
